import { z } from 'zod';
import { SapSystem } from './sap-system';

export { SapSystem, sapSystemSchema } from './sap-system';

export const SITES = [
  {
    code: 'ADGU',
    name: 'Guenzburg',
    system: SapSystem.NICE,
    plant: '069A',
    timeZone: 'Europe/Berlin',
    country: 'DE',
  },
  {
    code: 'ADZW',
    name: 'Zwickau',
    system: SapSystem.NICE,
    plant: '06ZK',
    timeZone: 'Europe/Berlin',
    country: 'DE',
  },
  {
    code: 'AEMO',
    name: 'Mollet',
    system: SapSystem.NICE,
    plant: '42M1',
    timeZone: 'Europe/Madrid',
    country: 'ES',
  },
  {
    code: 'AESC',
    name: 'Sant Celoni',
    system: SapSystem.NICE,
    plant: '42C1',
    timeZone: 'Europe/Madrid',
    country: 'ES',
  },
  {
    code: 'AFAU',
    name: 'Usine de Saint-Auban',
    system: SapSystem.NICE,
    plant: '01V3',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFCA',
    name: 'Usine de Carling',
    system: SapSystem.NICE,
    plant: '0134',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFCH',
    name: 'Usine de la Chambre',
    system: SapSystem.NICE,
    plant: '01KC',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFCO',
    name: 'Centre de Recherche Cerdato',
    system: SapSystem.NICE,
    plant: '0115',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFCR',
    name: 'Centre de Recherche Crra',
    system: SapSystem.NICE,
    plant: '01K8',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFCX',
    name: 'Site de Chateauroux',
    system: SapSystem.NICE,
    plant: '01CX',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFCY',
    name: 'Usine de Chauny',
    system: SapSystem.NICE,
    plant: '01V1',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFDR',
    name: 'Usine de Drocourt',
    system: SapSystem.NICE,
    plant: '0185',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFFE',
    name: 'Site de Feuchy',
    system: SapSystem.NICE,
    plant: '01FE',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFGE',
    name: 'Usine Genay',
    system: SapSystem.NICE,
    plant: '93GE',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFGR',
    name: 'Centre de Recherche Grl',
    system: SapSystem.NICE,
    plant: '01GR',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFJA',
    name: 'Usine de Jarrie',
    system: SapSystem.NICE,
    plant: '01K2',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFLZ',
    name: 'Usine de Lannemezan',
    system: SapSystem.NICE,
    plant: '01K9',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFMA',
    name: 'Usine de Marseille',
    system: SapSystem.NICE,
    plant: '0101',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFMO',
    name: 'Usine de Mont',
    system: SapSystem.NICE,
    plant: '0103',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFPB',
    name: 'Usine de Pierre-Benite',
    system: SapSystem.NICE,
    plant: '01K7',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFSQ',
    name: 'Usine de Serquigny',
    system: SapSystem.NICE,
    plant: '0102',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFTL',
    name: 'Usine de Lacq',
    system: SapSystem.NICE,
    plant: '01LC',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFTM',
    name: 'Usine de Mourenx',
    system: SapSystem.NICE,
    plant: '01MX',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AFVS',
    name: 'Usine de Villers Saint Paul',
    system: SapSystem.NICE,
    plant: '01VS',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'AIBO',
    name: 'Stabilimento di Boretto',
    system: SapSystem.NICE,
    plant: '09BT',
    timeZone: 'Europe/Rome',
    country: 'IT',
  },
  {
    code: 'AIGI',
    name: 'Gissi',
    system: SapSystem.NICE,
    plant: '09GS',
    timeZone: 'Europe/Rome',
    country: 'IT',
  },
  {
    code: 'AISP',
    name: 'Spinetta Marengo',
    system: SapSystem.NICE,
    plant: '09IP',
    timeZone: 'Europe/Rome',
    country: 'IT',
  },
  {
    code: 'AMKT',
    name: 'Atsb_kertih',
    system: SapSystem.NICE,
    plant: '7RKT',
    timeZone: 'Asia/Kuala_Lumpur',
    country: 'MY',
  },
  {
    code: 'ANBR',
    name: 'Plant Of Brummen',
    system: SapSystem.NICE,
    plant: '16BM',
    timeZone: 'Europe/Amsterdam',
    country: 'NL',
  },
  {
    code: 'ANMO',
    name: 'Moerdijk Site',
    system: SapSystem.NICE,
    plant: '8EMO',
    timeZone: 'Europe/Amsterdam',
    country: 'NL',
  },
  {
    code: 'ANRO',
    name: 'Plant',
    system: SapSystem.NICE,
    plant: '16RT',
    timeZone: 'Europe/Amsterdam',
    country: 'NL',
  },
  {
    code: 'ANVL',
    name: 'Vlissingen Plant',
    system: SapSystem.NICE,
    plant: '16VL',
    timeZone: 'Europe/Amsterdam',
    country: 'NL',
  },
  {
    code: 'ASJU',
    name: 'Plant Of Jurong',
    system: SapSystem.NICE,
    plant: '24JU',
    timeZone: 'Asia/Singapore',
    country: 'SG',
  },
  {
    code: 'AUAS',
    name: 'For Test Only',
    system: SapSystem.BEST,
    plant: 'US35',
    timeZone: 'America/New_York',
    country: 'US',
  },
  {
    code: 'AUCE',
    name: 'Arkema Us Chester South Carolina',
    system: SapSystem.NICE,
    plant: '7ACE',
    timeZone: 'America/New_York',
    country: 'US',
  },
  {
    code: 'AZJG',
    name: 'Plant Of Asp',
    system: SapSystem.NICE,
    plant: '5VZH',
    timeZone: 'Asia/Shanghai',
    country: 'CN',
  },
  {
    code: 'AZNS',
    name: 'Plant Of Nansha',
    system: SapSystem.NICE,
    plant: '5LNS',
    timeZone: 'Asia/Shanghai',
    country: 'CN',
  },
  {
    code: 'AZTX',
    name: 'Plant Of Taixing',
    system: SapSystem.NICE,
    plant: '6GTX',
    timeZone: 'Asia/Shanghai',
    country: 'CN',
  },
  {
    code: 'BAKP',
    name: 'Bostik Kings Park',
    system: SapSystem.BEST,
    plant: 'AU30',
    timeZone: 'Australia/Melbourne',
    country: 'AU',
  },
  {
    code: 'BATT',
    name: 'Bostik Thomastown',
    system: SapSystem.BEST,
    plant: 'AU30',
    timeZone: 'Australia/Melbourne',
    country: 'AU',
  },
  {
    code: 'BBNZ',
    name: 'Nazareth Plant',
    system: SapSystem.BEST,
    plant: 'BE01',
    timeZone: 'Europe/Brussels',
    country: 'BE',
  },
  {
    code: 'BFAV',
    name: 'Usine de Avelin',
    system: SapSystem.BEST,
    plant: 'FR12',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'BFCV',
    name: 'Usine de Coubert',
    system: SapSystem.BEST,
    plant: 'FR27',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'BFMP',
    name: 'Usine de le Meux',
    system: SapSystem.BEST,
    plant: 'FRC2',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'BFPV',
    name: 'Usine de Privas',
    system: SapSystem.BEST,
    plant: 'FR01',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'BFRI',
    name: 'Usine de Ribecourt',
    system: SapSystem.BEST,
    plant: 'FR04',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'BFSV',
    name: 'Usine de Sainville',
    system: SapSystem.BEST,
    plant: 'FR21',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'BIMO',
    name: 'Stabilimento di Mozzate',
    system: SapSystem.BEST,
    plant: 'IT04',
    timeZone: 'Europe/Rome',
    country: 'IT',
  },
  {
    code: 'BIPA',
    name: 'Stabilimento di Parona',
    system: SapSystem.BEST,
    plant: 'IT05',
    timeZone: 'Europe/Rome',
    country: 'IT',
  },
  {
    code: 'BMTL',
    name: 'Toluca Plant',
    system: SapSystem.BEST,
    plant: 'MX23',
    timeZone: 'America/Mexico_City',
    country: 'MX',
  },
  {
    code: 'BNGN',
    name: 'Giessen Plant',
    system: SapSystem.BEST,
    plant: 'NL13',
    timeZone: 'Europe/Amsterdam',
    country: 'NL',
  },
  {
    code: 'BNOO',
    name: 'Oosterhout Plant',
    system: SapSystem.BEST,
    plant: 'NL12',
    timeZone: 'Europe/Amsterdam',
    country: 'NL',
  },
  {
    code: 'BPTN',
    name: 'Tanay Plant',
    system: SapSystem.BEST,
    plant: 'PH30',
    timeZone: 'Asia/Manila',
    country: 'PH',
  },
  {
    code: 'BUAO',
    name: 'Ashland Ohio',
    system: SapSystem.BEST,
    plant: 'US35',
    timeZone: 'America/New_York',
    country: 'US',
  },
  {
    code: 'BUCC',
    name: 'Calumet City',
    system: SapSystem.BEST,
    plant: 'US38',
    timeZone: 'America/Chicago',
    country: 'US',
  },
  {
    code: 'BUCO',
    name: 'Columbus',
    system: SapSystem.BEST,
    plant: 'US36',
    timeZone: 'America/New_York',
    country: 'US',
  },
  {
    code: 'BUEG',
    name: 'Elk Grove Village, Il',
    system: SapSystem.BEST,
    plant: 'US41',
    timeZone: 'America/Chicago',
    country: 'US',
  },
  {
    code: 'BUPD',
    name: 'Piedmont Plant',
    system: SapSystem.BEST,
    plant: 'US39',
    timeZone: 'America/New_York',
    country: 'US',
  },
  {
    code: 'BURI',
    name: 'Ringwood Plant',
    system: SapSystem.BEST,
    plant: 'US40',
    timeZone: 'America/Chicago',
    country: 'US',
  },
  {
    code: 'BUWC',
    name: 'White City Plant',
    system: SapSystem.BEST,
    plant: 'US37',
    timeZone: 'America/Los_Angeles',
    country: 'US',
  },
  {
    code: 'BZCS',
    name: 'Bostik Cs',
    system: SapSystem.BEST,
    plant: 'CNJ1',
    timeZone: 'Asia/Shanghai',
    country: 'CN',
  },
  {
    code: 'BZGZ',
    name: 'Guangzhou',
    system: SapSystem.BEST,
    plant: 'CNG1',
    timeZone: 'Asia/Shanghai',
    country: 'CN',
  },
  {
    code: 'BZSH',
    name: 'Fixatti Sh',
    system: SapSystem.BEST,
    plant: 'CNF1',
    timeZone: 'Asia/Shanghai',
    country: 'CN',
  },
  {
    code: 'KFSF',
    name: 'Usine de Saint Fons',
    system: SapSystem.NICE,
    plant: '01SF',
    timeZone: 'Europe/Paris',
    country: 'FR',
  },
  {
    code: 'XUAO',
    name: 'Ashland Ohio',
    system: SapSystem.BEST,
    plant: 'US35',
    timeZone: 'America/New_York',
    country: 'US',
  },
  {
    code: 'XUCC',
    name: 'Calumet City',
    system: SapSystem.BEST,
    plant: 'US38',
    timeZone: 'America/Chicago',
    country: 'US',
  },
  {
    code: 'XUCO',
    name: 'Columbus (Obsolete Objects)',
    system: SapSystem.BEST,
    plant: 'US36',
    timeZone: 'America/New_York',
    country: 'US',
  },
  {
    code: 'XUWC',
    name: 'White City Deleted Object',
    system: SapSystem.BEST,
    plant: 'US37',
    timeZone: 'America/Los_Angeles',
    country: 'US',
  },
] as const;

export const SITE_CODES = SITES.map((site) => site.code) as [
  (typeof SITES)[number]['code'],
  ...(typeof SITES)[number]['code'][],
];

export const siteCodeSchema = z.enum(SITE_CODES);
export type SiteCode = z.infer<typeof siteCodeSchema>;

export type Site = (typeof SITES)[number];

export function siteOf(code: SiteCode): Site {
  const found = SITES.find((site) => site.code === code);
  if (!found) throw new Error(`Unknown site: ${code}`);
  return found;
}

export const sapSystemOf = (code: SiteCode): SapSystem => siteOf(code).system;

/** IANA time zone of the site: SAP timestamps are local to it. */
export const timeZoneOf = (code: SiteCode): string => siteOf(code).timeZone;
